import { render, staticRenderFns } from "./CarBrand.vue?vue&type=template&id=6910caf6&scoped=true"
import script from "./CarBrand.vue?vue&type=script&lang=ts"
export * from "./CarBrand.vue?vue&type=script&lang=ts"
import style0 from "./CarBrand.vue?vue&type=style&index=0&id=6910caf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6910caf6",
  null
  
)

export default component.exports